import {
  FETCH_LETTERS_TEMPLATES_LIST,
  CREATE_LETTER_TEMPLATE,
  DELETE_LETTER_TEMPLATE,
  UPDATE_LETTER_TEMPLATE,
  RETRIEVE_LETTER_TEMPLATE,
  UPDATE_THUMBNAIL,
  FETCH_PRODUCT_CODES_LIST,
} from "./types";
import { sortSearchPaginateActions } from "@/store/common/actions";
import * as lettersApi from "@/api-client/letters";

export default {
  async fetchProductCodesList(
    { commit },
    { page, sort, page_size, search, queryString } = {}
  ) {
    commit({
      type: FETCH_PRODUCT_CODES_LIST.request,
    });

    try {
      const resp = await lettersApi.fetchProductCodesList({
        sort,
        page,
        page_size,
        search,
        queryString,
      });

      commit({
        type: FETCH_PRODUCT_CODES_LIST.success,
        payload: resp.items.map((item) => ({
          value: item.id,
          key: item.id,
          label: item.revision ? `${item.name}_${item.revision}` : item.name,
        })),
      });
    } catch (e) {
      commit({
        type: FETCH_PRODUCT_CODES_LIST.error,
        error: e.message,
      });
    }
  },

  async fetchLettersTemplatesList(
    { commit },
    { page, sort, search, page_size, queryString } = {}
  ) {
    commit({
      type: FETCH_LETTERS_TEMPLATES_LIST.request,
    });

    try {
      const letterTemplateList = await lettersApi.fetchLettersTemplatesList({
        page,
        sort,
        search,
        page_size,
        queryString,
      });

      commit({
        type: FETCH_LETTERS_TEMPLATES_LIST.success,
        payload: letterTemplateList,
      });
    } catch (e) {
      commit({
        type: FETCH_LETTERS_TEMPLATES_LIST.error,
        error: e.message,
      });
    }
  },

  async fetchTemplateById({ commit }, { id, onSuccess }) {
    commit({
      type: RETRIEVE_LETTER_TEMPLATE.request,
    });

    try {
      const template = await lettersApi.fetchLettersTemplateById(id);
      commit({
        type: RETRIEVE_LETTER_TEMPLATE.success,
        payload: template,
      });

      onSuccess ? onSuccess(template) : null;

      return template;
    } catch (e) {
      commit({
        type: RETRIEVE_LETTER_TEMPLATE.error,
        error: e.message,
      });
    }
  },

  async updateLettersTemplate(
    { commit, dispatch, state },
    { data, onSuccess, onError, silent = false }
  ) {
    if (!silent) {
      commit({
        type: UPDATE_LETTER_TEMPLATE.request,
      });
    }

    try {
      const { id, ...rest } = data;

      const template = await lettersApi.updateLettersTemplate(id, rest);

      if (!silent) {
        commit({
          type: UPDATE_LETTER_TEMPLATE.success,
          payload: { ...template, id },
        });
      }

      onSuccess ? onSuccess(template) : null;
    } catch (e) {
      commit({
        type: UPDATE_LETTER_TEMPLATE.error,
        error: e.message,
      });

      onError ? onError(e.message) : null;
    }
  },

  async createLetterTemplate({ commit }, { data, onSuccess, onError } = {}) {
    commit({
      type: CREATE_LETTER_TEMPLATE.request,
    });

    try {
      const template = await lettersApi.createLettersTemplate(data);

      commit({
        type: CREATE_LETTER_TEMPLATE.success,
        payload: template,
      });

      onSuccess ? onSuccess(template) : null;
    } catch (e) {
      commit({
        type: CREATE_LETTER_TEMPLATE.error,
        error: e.errors,
      });

      onError && onError(e);
    }
  },

  async deleteLetterTemplate({ commit }, { id, onSuccess, onError }) {
    commit({
      type: DELETE_LETTER_TEMPLATE.request,
    });

    try {
      await lettersApi.deleteLettersTemplate(id);
      commit({
        type: DELETE_LETTER_TEMPLATE.success,
        payload: id,
      });

      onSuccess ? onSuccess() : null;
    } catch (e) {
      commit({
        type: DELETE_LETTER_TEMPLATE.error,
        error: e.message,
      });

      onError ? onError() : null;
    }
  },

  async updatePreview({ commit }, { id, onSuccess, onError }) {
    commit({
      type: UPDATE_THUMBNAIL.request,
    });

    try {
      await lettersApi.updateThumbnail(id);

      commit({
        type: UPDATE_THUMBNAIL.success,
        payload: id,
      });

      onSuccess ? onSuccess() : null;
    } catch (e) {
      commit({
        type: UPDATE_THUMBNAIL.error,
        error: e.message,
      });

      onError ? onError() : null;
    }
  },

  ...sortSearchPaginateActions,
};
